import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Link from "@tiptap/extension-link";
import Bold from "@tiptap/extension-bold";
import Underline from "@tiptap/extension-underline";
import Italic from "@tiptap/extension-italic";
import Strike from "@tiptap/extension-strike";
import History from "@tiptap/extension-history";
import Placeholder from "@tiptap/extension-placeholder";
import { Node } from "@tiptap/core";

// `schema` var et TipTap 1-API. TipTap 2 læste det aldrig, og TipTap 3's typer
// afviser det, så noden har hele tiden kun haft sit navn. Fjernet uden
// adfærdsændring.
const CustomParagraph = Node.create({
  name: "custom_paragraph",
});

export const emailEditorConfig = {
  extensions: [
    Document,
    History,
    Paragraph,
    Text,
    Link.configure({
      openOnClick: false,
      linkOnPaste: true,
      validate: (href) => /^https?:\/\//.test(href),
    }),
    Bold,
    Underline,
    Italic,
    Strike,
    Placeholder.configure({
      placeholder: "Din besked",
    }),
    CustomParagraph,
  ],
};

export const acceptedFileTypes =
  "text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,image/jpeg,image/png,application/rtf";
